import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { AuthShell, Field, primary, link, errText } from '../components/AuthShell';
import { SetupFeeBanner } from '../components/SetupFeeBanner';

export default function Signup() {
  const { login } = useContext(AuthContext);
  const nav = useNavigate();
  const [plans, setPlans] = useState(null);
  const [f, setF] = useState({ company_name: '', name: '', email: '', password: '', phone: '', plan: 'pro' });
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));
  useEffect(() => { axios.get('/public/plans').then((r) => setPlans(r.data)).catch(() => setPlans({ plans: [], self_signup: true, trial_days: 14 })); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (f.password.length < 8) return toast.error('Password must be at least 8 characters');
    setBusy(true);
    try {
      const { data } = await axios.post('/public/signup', f);
      sessionStorage.setItem('post_signup', '1');
      login(data.token, data.user);
      toast.success(`Welcome to ${data.user.company.name}! Your ${plans?.trial_days || 14}-day trial has started.`);
      nav('/welcome', { replace: true });
    } catch (err) { toast.error(errText(err, 'Signup failed')); } finally { setBusy(false); }
  };

  if (plans && plans.self_signup === false) {
    return <AuthShell title="Signups are by invitation" subtitle="Request a demo and we'll set up your workspace." testId="signup-closed"><a href="/" style={link}>Back to the website</a></AuthShell>;
  }
  return (
    <AuthShell title="Start your free trial" subtitle={`${plans?.trial_days || 14} days free · no card required · your trial never converts to a paid plan automatically`} testId="signup-page"
      footer={<>Already have an account? <a href="/login" style={link} data-testid="signup-login-link">Sign in</a></>}>
      <form onSubmit={submit} data-testid="signup-form">
        <Field id="signup-company" value={f.company_name} onChange={set('company_name')} placeholder="Acme Screen Printing" required minLength={2}>Shop / company name</Field>
        <Field id="signup-name" value={f.name} onChange={set('name')} placeholder="Your full name" required>Your name</Field>
        <Field id="signup-email" type="email" value={f.email} onChange={set('email')} placeholder="you@yourshop.com" required>Work email</Field>
        <Field id="signup-phone" type="tel" value={f.phone} onChange={set('phone')} placeholder="(555) 555-5555">Phone (optional)</Field>
        <Field id="signup-password" type="password" value={f.password} onChange={set('password')} placeholder="At least 8 characters" required minLength={8} autoComplete="new-password">Password</Field>
        {plans?.plans?.length > 0 && (
          <div style={{ marginTop: 16 }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: '#CBD5E1', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Plan to trial</span>
            <div style={{ display: 'grid', gap: 8, marginTop: 8 }}>
              {plans.plans.map((p) => (
                <label key={p.id} data-testid={`signup-plan-${p.id}`} style={{ display: 'flex', gap: 10, alignItems: 'center', border: `1px solid ${f.plan === p.id ? '#6366F1' : '#334155'}`, borderRadius: 10, padding: '10px 12px', cursor: 'pointer', background: f.plan === p.id ? '#1E1B4B' : 'transparent' }}>
                  <input type="radio" name="plan" checked={f.plan === p.id} onChange={() => set('plan')(p.id)} />
                  <span style={{ fontWeight: 700 }}>{p.name}</span><span style={{ color: '#94A3B8', fontSize: 13 }}>${p.price_monthly}/mo once activated</span>
                </label>
              ))}
            </div>
            <SetupFeeBanner compact />
          </div>
        )}
        <button type="submit" style={primary} disabled={busy} data-testid="signup-submit">{busy ? 'Creating your workspace…' : 'Create my workspace'}</button>
        <p style={{ fontSize: 12, color: '#64748B', marginTop: 12 }}>By continuing you agree to the Terms of Service and Privacy Policy.</p>
      </form>
    </AuthShell>
  );
}
